module.exports = __webpack_public_path__ + "5659aa3ad1452f270fa57a549055cc73.png";